import { useLoader } from "../context/LoaderContext";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { IBannerData, IGalleryData } from "../exports/interfaces";
import { fetchGallery } from "../api/GalleryApi";
import { dynamicFailed } from "../hooks/custom/useToast";
import GalleryView from "../components/gallery/GalleryView";
import Banner from "../components/Banner";
import { fetchGalleryBanner } from "../api/BannerApi";

const GalleryViewPage = () => {
  const location = useLocation();
  const params = useParams();
  const { setLoading } = useLoader();

  const [gallery, setGallery] = useState<IGalleryData[]>([]);
  const [galleryBanner, setGalleryBanner] = useState<IBannerData[]>([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchGallery(), fetchGalleryBanner()])
      .then(([galleryData, galleryBannerData]) => {
        setGallery(galleryData);
        setGalleryBanner(galleryBannerData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  const state = location.state as { id?: number } | null;
  const galleryId = params.id ? Number(params.id) : state?.id;

  return (
    <>
      <Banner title="Gallery" bannerImage={galleryBanner?.[0]?.image?.[0]} />
      <GalleryView id={galleryId || 0} galleryImagesData={gallery} />
    </>
  );
};

export default GalleryViewPage;
